export const AccordionVariants = {
  wrapper: {
    initial: {
      y: '100%',
      opacity: 0,
    },
    animate: ({ delay = 0 }) => ({
      y: '0%',
      opacity: 1,
      transition: {
        duration: 0.4,
        ease: 'easeOut',
        delay,
      },
    }),
  },
  innerContent: {
    initial: {
      height: 0,
      y: '60px',
      opacity: 0,
      transition: {
        duration: 0.3,
        ease: 'easeIn',
      },
    },
    animate: {
      y: '0%',
      height: 'auto',
      opacity: 1,
      transition: {
        duration: 0.4,
        ease: 'easeIn',
      },
    },
  },
};
